// extracted by mini-css-extract-plugin
export default {"divmapa":"Mapa_divmapa__Z5grR","onde":"Mapa_onde__2oTyg"};